import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Util from 'utils';
import { Toast } from 'antd-mobile';
import ShopHomeServ from '@/pages/Shop/Home/ShopHome/ShopHomeServ.js';

@inject('AppMod')
@inject('ShopHomeMod')
@withRouter
@observer
class TransitView extends Component {
  constructor(props, context) {
    super(props, context);
    this.registerMemGiftbag = {
      // 一星
      '1357052080262716503': {
        applyType: '4',
        card: {
          bv: null,
          bvMode: 0,
          id: '1357052080262716503',
          maxAmount: 27000,
          minAmount: 3968,
          type: 2
        },
        cardTypeId: '1357052080262716503',
        inletTitle: '',
        sourceTag: ''
      },
      // 二星
      '1413409810715755640': {
        applyType: '4',
        card: {
          bv: null,
          bvMode: 0,
          id: '1413409810715755640',
          maxAmount: 35000,
          minAmount: 27315,
          type: 3
        },
        cardTypeId: '1413409810715755640',
        inletTitle: '',
        sourceTag: ''
      },
      // 体验赋能
      '1428623010573728891': {
        applyType: '4',
        card: {
          bv: 40000,
          bvMode: 1,
          id: '1428623010573728891',
          maxAmount: 51200,
          minAmount: 49688,
          type: 4
        },
        cardTypeId: '1428623010573728891',
        inletTitle: '',
        sourceTag: ''
      }
    };
    this.shopHomeMod = this.props.ShopHomeMod;
  }

  componentDidMount() {
    this.props.AppMod.checkFreeLogin(() => {
      this.props.AppMod.getUserInfo().then(() => {
        this.handleTransit();
      });
    });
  }
  /**
   * 跳转到健康家,1:2专区
   */
  jumpHealthHome = (targetId) => {
    // 此方法会延迟1-2秒左右才会跳转，大概有5个接口左右

    // 获取首页广告图数据列表，从中取出健康家专区,1:2专区信息，并跳转
    try {
      ShopHomeServ.getAdvPicture().then((result) => {
        const { data, resultCode } = result;
        if (resultCode == '0' && data) {
          const healthData = data.find((item) => item.content == targetId);
          if (healthData) {
            this.shopHomeMod.doLinkJump(healthData);
          }
        }
      });
    } catch (e) {
      console.log(e);
    }

    return;
  };

  handleTransit = () => {
    // 1. 获取最外层的 search 参数（包含 targetUrl=xxx）
    const searchStr = this.props.location.search || '';

    // 2. 自定义解析，防止因为 Util.decodeQuery 内部逻辑导致嵌套的 '&' 或 '=' 被截断
    const queryParams = {};
    if (searchStr) {
      const cleanSearch = searchStr.replace('?', '');
      // 使用正则精准提取 targetUrl 后的内容
      const targetUrlMatch = cleanSearch.match(/targetUrl=([^&]+)/);
      if (targetUrlMatch && targetUrlMatch[1]) {
        queryParams.targetUrl = decodeURIComponent(targetUrlMatch[1]);
      }
    }

    // 3. 判断是否存在 targetUrl
    if (queryParams.targetUrl) {
      const targetUrlStr = queryParams.targetUrl;
      let pathname = targetUrlStr;
      let state = {};

      if (targetUrlStr.includes('?')) {
        const parts = targetUrlStr.split('?');
        pathname = parts[0];

        // 提取后面的 search 参数作为传递给下个页面的 state
        const targetSearchStr = parts.slice(1).join('?');

        if (targetSearchStr) {
          const searchArr = targetSearchStr.split('&');
          searchArr.forEach((item) => {
            const [key, ...valueParts] = item.split('=');
            if (key) {
              let value = valueParts.join('=');
              value = decodeURIComponent(value || '');

              // 针对复杂对象参数 (如 card) 进行自动序列化解析
              if (key === 'card' && value) {
                try {
                  value = JSON.parse(value);
                } catch (e) {
                  console.error('card参数解析失败', e);
                }
              }
              state[key] = value;
            }
          });
        }
      }
      // 如果传入了 id（或 cardTypeId），则直接从本地配置中提取完整的预设参数
      const targetId = state.id || state.cardTypeId;
      // 如果目标路由是 register/memGiftbag，进行极简传参改造拦截
      if (pathname.includes('register/memGiftbag')) {
        if (targetId && this.registerMemGiftbag[targetId]) {
          // 提取预设参数
          const presetParams = this.registerMemGiftbag[targetId];
          // 核心合并逻辑：先放预设参数，再放 URL 解析出来的 state，
          // 这样 URL 里的 HealthyCardCode 等任何额外参数都会自然覆盖预设（并且预设里我们已经删掉了硬编码的 HealthyCardCode）
          state = {
            ...presetParams, // 注入预设复杂参数
            ...state // 外部传入参数优先级最高，保留原有的其他参数
          };
        }
      } else if (['1400263932459994120', '1379226846643840037'].includes(targetId)) {
        // 跳转健康家专区,消费合伙人1:2专区
        this.jumpHealthHome(targetId);
        return;
      }

      // 4. 执行中转跳转
      // 框架底层的 routerRedirect 会自动将其转化为 _k=xxxx 并存入 sessionStorage
      window.app.routerRedirect({
        pathname: pathname,
        state: state
      });
    } else {
      // 异常处理：如果没有指定目标地址，跳回首页或给予提示
      Toast.fail('缺少目标跳转地址', 2, () => {
        window.app.routerRedirect('/shop/home');
      });
    }
  };

  render() {
    // 中转页不需要展示实际内容，或者可以展示一个全局 Loading 状态
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}>
        <span>...</span>
      </div>
    );
  }
}

export default TransitView;



// WEBPACK FOOTER //
// ./src/pages/Transit/TransitView.js